<template>
  <div class="container-fluid">
    <supplier-form
      :loading="loading"
      :supplierData="supplier"
      :formErrors="formErrors"
      @supplierSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import SupplierForm from "../partials/SupplierForm.vue";
import defaultSupplier from "../defaultSupplier";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    SupplierForm,
  },

  mixins: [alertLeave],

  data() {
    const supplier = cloneDeep(defaultSupplier);
    return {
      supplier: supplier,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    async handleSubmit(supplier) {
      this.loading = true;
      const supplierData = cloneDeep(supplier);

      try {
        await this.$store.dispatch("suppliers/add", supplierData);
        this.$notify({
          type: "success",
          message: this.$t("SUPPLIERS.SUPPLIER_ADDED"),
        });
        const supplier = await this.$store.getters["suppliers/supplier"];
        this.$emit("onViewSupplier", supplier, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
